import React from 'react';
import { Link } from 'react-router-dom';
import { QRBranding } from '../../utils/branding';

interface QRPageFooterProps {
  branding: QRBranding | null;
  className?: string;
}

export const QRPageFooter: React.FC<QRPageFooterProps> = ({ branding, className = '' }) => {
  // If branding is not loaded yet or showBranding is false, don't show footer
  if (!branding || !branding.showBranding) {
    return null;
  }

  return (
    <div className={`text-center ${className}`}>
      <p className="text-sm" style={{ color: branding.secondaryColor || '#6B7280' }}>
        {branding.companyName === 'BeyondPages' ? (
          <>
            Powered by BeyondPages
          </>
        ) : (
          <>
            © 2024 {branding.companyName}
          </>
        )}
      </p>
      {branding.companyName === 'BeyondPages' && (
        <Link 
          to="/" 
          className="text-sm underline mt-2 inline-block hover:opacity-80"
          style={{ color: branding.primaryColor || '#0055AA' }}
        >
          Learn more about BeyondPages
        </Link>
      )}
    </div>
  );
}; 